import { Button } from "@rosette/web_components/src/ui/Button.js";
import { MENU_BUTTON, MenuOptions } from "@/components/game/menu/MenuLayout.js";
import { PreferencesPanel } from "@/components/user/PreferencesPanel.js";
import type { MutableRefObject } from "react";
import React from "react";
import { useAssetLoader } from "@/components/assets/AssetContext.js";
import { Card } from "@rosette/web_components/src/ui/Card.js";


interface PreferencesMenuProps {
    contentRef: MutableRefObject<HTMLDivElement | null>;
    back: () => void;
}


export function PreferencesMenu({ contentRef, back }: PreferencesMenuProps) {
    const assetLoader = useAssetLoader();
    return (
        <MenuOptions contentRef={contentRef}>
            <Card className="px-6 pt-6 pb-3 md:pt-6 md:pb-3">
                <h2 className="mt-0">
                    Game Preferences
                </h2>
                <PreferencesPanel
                    assetLoader={assetLoader} />
            </Card>

            <Button
                size="lg"
                className={MENU_BUTTON}
                onClick={back}>
                Back
            </Button>
        </MenuOptions>
    );
}
